import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import QuickEditButton from './QuickEditButton';

const QuickEditButtonPicker = (props) => {
  const { resource } = useMetaLayoutContext();

  return pickFunction(resource, {
    [fr.relationships.outcomeQuickEdit.name]: () => {
      return (
        <QuickEditButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default QuickEditButtonPicker;
